/**
 * Created by wjjn3481 on 2017/4/13.
 */

export default {
    phone: /^[1-9]\d{10,10}$/,    // 手机号
    number: /(?:\d*\.)?\d+/       // 数字
}


// WEBPACK FOOTER //
// ./src/modules/pattern.js